// extracted by mini-css-extract-plugin
export default {"verticalLine":"divider_verticalLine__GCMsu","dividerCenter":"divider_dividerCenter__Lk2Dw"};